export const AppInsightsEvents = {
  UserLoginEvent: "User Login Event",
  UserLogoutEvent: "User Logout Event",
};
